<template>
  <div
    id="app"
    class="game-detail"
    :style="{ 'padding-bottom': isFullScreen ? '88px' : '64px' }"
    v-hb-loading.fullscreen.lock="showLoading"
    hb-loading-bg="rgba(255, 255, 255, 1)"
    hb-loading-circle-bg="#DADDE0"
    hb-loading-color="#64696E"
  >
    <header-share
      desc="高能玩家聚集地"
      opacity="1"
      :title="is_concept ? '小黑盒概念版' : '小黑盒'"
      :logo-img="
        is_concept
          ? 'https://imgheybox.max-c.com/oa/2022/04/22/16a033ba9c4b74665c0a2a6266375afc.png'
          : ''
      "
      :pageKey="'gameshare'"
      @click.capture.native="reportShare('download')"
    ></header-share>
    <div
      class="game-buy-share-btn"
      :style="{ height: isFullScreen ? '88px' : '64px' }"
      @click="openInHeybox"
    >
      <OutOpen
        :protocol="heybox_protocol"
        :page-identifier="'game/detail'"
        v-if="canUseDeepLink"
      ></OutOpen>
      <div class="btn-wrapper">
        <template v-if="heybox_price">
          <div class="btn-wishlist gray" v-if="display_add_wishlist">
            <p>一键添加愿望单</p>
          </div>
          <div class="btn-buy">
            <img
              class="unit"
              src="./assets/images/4-wallet_money_filled_24x24.png"
              alt=""
            />
            <p class="cost">{{ heybox_price.cost_coin | formatCoin }}</p>
            <p class="desc-1">购买</p>
            <p class="desc-2" v-if="!display_add_wishlist">新人更有专属优惠</p>
          </div>
        </template>
        <template v-else>
          <template v-if="display_add_wishlist">
            <div class="btn-follow-small">
              <img
                src="https://imgheybox.max-c.com/oa/2024/06/27/8d9e6b908e2acd358c79aa4fa0224f2d.png"
                alt=""
              />
              <p>关注</p>
            </div>
            <div class="btn-wishlist">
              <p>一键添加愿望单</p>
            </div>
          </template>
          <div class="btn-follow-large" v-else>
            <p>关注</p>
          </div>
        </template>
      </div>
    </div>
    <Medias
      :medias="screenshots"
      :protocol="heybox_protocol"
      :can-use-deep-link="canUseDeepLink"
      @openInHeybox="openInHeybox"
    ></Medias>
    <div class="price-row" v-if="price" :class="{ lowest: price.new_lowest }">
      <p class="unit" v-if="price">¥</p>
      <p class="current" v-if="price">{{ price.current }}</p>
      <p class="default" v-if="!price">暂无价格</p>
      <div class="discount-info" v-if="(price && price.discount) || couponDesc">
        <p v-if="priceDesc" class="desc">{{ priceDesc }}</p>
        <div class="discount-off">
          <div v-if="price && price.discount" class="discount-box">
            <p class="discount">-{{ price.discount }}%</p>
            <p class="original">¥{{ price.initial }}</p>
          </div>
          <div v-if="couponDesc" class="discount-coupon" @click="openInHeybox">
            <OutOpen
              :protocol="heybox_protocol"
              :page-identifier="'game/detail'"
              v-if="canUseDeepLink"
            ></OutOpen>
            <span>{{ couponDesc }}</span>
            <img src="./assets/images/triangle.svg" alt="" />
          </div>
        </div>
      </div>
      <div class="btn-trend" @click="openInHeybox">
        <OutOpen
          :protocol="heybox_protocol"
          :page-identifier="'game/detail'"
          v-if="canUseDeepLink"
        ></OutOpen>
        全区价格/趋势<img src="./assets/images/triangle.svg" alt="" />
      </div>
    </div>
    <div class="game-data">
      <div class="row-1">
        <div class="game-name">
          <p class="name" v-if="name" :class="{ small: getStrLen(name) >= 30 }">
            {{ name }}
          </p>
          <p class="name-en" v-if="name_en">{{ name_en }}</p>
        </div>
        <div class="score-wrapper">
          <div
            class="score"
            :class="
              'score-' +
              (score >= 9
                ? 1
                : score >= 7
                  ? 2
                  : score >= 5
                    ? 3
                    : score >= 0
                      ? 4
                      : 'null')
            "
          >
            <img
              v-if="score >= 0"
              src="./assets/images/heybox_logo2.png"
              alt=""
            />
            <p class="num" v-if="score >= 0">{{ score }}</p>
            <p class="null" v-else>暂无评分</p>
          </div>
          <div class="comment">
            <span>{{ commentDesc }}</span>
          </div>
        </div>
      </div>
      <div class="row-2">
        <div class="tags">
          <p
            class="tag plat"
            v-if="platforms.length > 0"
            :class="platf"
            @click="openInHeybox"
          >
            <OutOpen
              :protocol="heybox_protocol"
              :page-identifier="'game/detail'"
              v-if="canUseDeepLink"
            ></OutOpen>
            <img
              v-for="(p, index) in platforms"
              :key="index"
              :src="require(`./assets/images/plat/${p}.svg`)"
              :class="{ on: p == platf }"
              alt=""
            />
          </p>
          <div
            v-for="(tag, i) in steam_aggres"
            :key="`steam_${i}`"
            class="tag common"
            :style="`color: ${tag.text_color}; background: ${tag.background_color};`"
            @click="openInHeybox"
          >
            <OutOpen
              :protocol="heybox_protocol"
              :page-identifier="'game/detail'"
              v-if="canUseDeepLink"
            ></OutOpen>
            <span v-for="desc in tag.desc_list" :key="desc">{{ desc }}</span>
          </div>
          <p
            class="tag"
            v-for="(tag, i) in simple_tags"
            :key="`simple_${i}`"
            :style="`color: ${tag.text_color}; background: ${tag.background_color};`"
          >
            {{ tag.desc }}
          </p>
          <div
            v-for="(tag, i) in heybox_tags"
            :key="`heybox_${i}`"
            class="tag user"
          >
            <PercentrRing :percent="tag.percent"></PercentrRing>
            <span>{{ tag.desc }}</span>
          </div>
        </div>
      </div>
      <div class="row-3">
        <div class="data-list">
          <div class="data-item" v-for="item in data_list" :key="item.desc">
            <div
              class="peak-canvas"
              v-if="item.peak_values && item.peak_values.length != 0"
            ></div>
            <div
              v-else-if="item.hb_rich_text"
              class="editor"
              v-html="getHtml(item.hb_rich_text)"
            ></div>
            <p class="p1" v-else>{{ item.value }}</p>
            <p class="p2">{{ item.desc }}</p>
            <p class="p3" v-if="item.rank">{{ item.rank }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="game-info">
      <div class="section-title">
        <p class="title">游戏简介</p>
        <p class="tag" v-if="is_official">官方入驻</p>
        <p class="btn btn-all" @click="openInHeybox">
          <OutOpen
            :protocol="heybox_protocol"
            :page-identifier="'game/detail'"
            v-if="canUseDeepLink"
          ></OutOpen>
          <span>全部</span><img src="./assets/images/arrow.png" alt="" />
        </p>
      </div>
      <p class="about-game">{{ about_the_game }}</p>
      <div class="menu-list" v-if="menus.length > 0">
        <div class="menu-item" :key="index" v-for="(item, index) in menus">
          <OutOpen
            v-if="['homepage', 'qq'].indexOf(item.type) == -1 && canUseDeepLink"
            :protocol="heybox_protocol"
            :page-identifier="'game/detail'"
          ></OutOpen>
          <p>
            <span>{{ item.title }}</span>
            <span
              :class="{
                on:
                  ['developer', 'publisher', 'homepage', 'qq'].indexOf(
                    item.type,
                  ) >= 0,
                qq: item.type == 'qq',
                mscore: item.type === 'mscore',
              }"
              :style="
                item.type === 'mscore' ? `background-color: ${item.color};` : ''
              "
              :data-clipboard-text="item.value"
              @click="menuClickHandler(item)"
              >{{ item.value }}</span
            >
          </p>
        </div>
      </div>
    </div>
    <div class="rating-container">
      <div class="section-title">
        <p class="title">游戏评价</p>
      </div>
      <div class="rating-wrapper">
        <div class="rating-box">
          <div
            class="rate"
            :class="
              'score-' +
              (score >= 9
                ? 1
                : score >= 7
                  ? 2
                  : score >= 5
                    ? 3
                    : score >= 0
                      ? 4
                      : 'null')
            "
          >
            <div class="rate-score" :class="{ disable: score == -1 }">
              {{ score >= 0 ? score : '暂无评分' }}
            </div>
            <div class="rate-sub">{{ commentDesc }}</div>
          </div>
        </div>
        <div class="rank-wrap">
          <div class="rank-row" v-for="item in 5" :key="item">
            <i class="hb-star" v-for="star in 6 - item" :key="star">&#xe684;</i>
          </div>
        </div>
        <div class="rank-progress">
          <div class="progress-row" v-for="item in 5" :key="item">
            <div class="star-progress-wrap">
              <div
                class="star-progress"
                :style="{ width: `${comment_stats[`star_${6 - item}`]}%` }"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="comments-wrapper" v-if="comments.length > 0">
      <div class="section-title">
        <p class="title">最有价值评论</p>
      </div>
      <div class="comments-list">
        <comment-item
          v-for="comment in comments"
          :key="comment.linkid"
          :link="comment"
          :protocol="heybox_protocol"
          :can-use-deep-link="canUseDeepLink"
        ></comment-item>
        <div class="btn-download" @click="openInHeybox">
          <OutOpen
            :protocol="heybox_protocol"
            :page-identifier="'game/detail'"
            v-if="canUseDeepLink"
          ></OutOpen>
          打开{{ is_concept ? '小黑盒概念版' : '小黑盒' }}，查看更多精彩评价
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getUrlParam,
  wxShare,
  isFullScreen,
  getDomByJson,
  executeProtocolOutApp,
} from '_lib/utils';
import HeaderShare from '_com/base/ShareHeader';
import OutOpen from '_com/OutOpen';
import Medias from './components/medias.vue';
import CommentItem from './components/comment-item.vue';
import PercentrRing from './components/percent-ring.vue';

import ClipboardJS from 'clipboard';
import { getGameDetail } from '_api/game';
import { getGameComments } from '_api/bbs/bbs';
import { getShareInfo } from '_api/wx_share';
import { reportDataWeb } from '_api/web-report';

import * as echarts from 'echarts/core';
import { LineChart } from 'echarts/charts';
import { GridComponent } from 'echarts/components';
import { SVGRenderer } from 'echarts/renderers';
echarts.use([LineChart, SVGRenderer, GridComponent]);

export default {
  data() {
    return {
      h_src: getUrlParam('h_src'),
      screenshots: [],
      price: null,
      heybox_price: null,
      display_add_wishlist: 0,
      name: '',
      name_en: '',
      score: -1,
      simple_tags: [], // 一般标签
      steam_aggres: [], // steam标签
      heybox_tags: [], // 用户自定义标签
      platf: '',
      platforms: [],
      data_list: [],
      is_official: 0,
      about_the_game: '',
      menus: [],
      dlcs: [],
      comment_stats: {},
      comments: [],
      showLoading: true,
      is_concept: getUrlParam('concept') == 1,

      shareConfig: null,
      canUseDeepLink: false,
      isFullScreen: isFullScreen(),
    };
  },
  computed: {
    commentDesc() {
      let num = '';
      let suffix = '';
      if (this.score >= 0) {
        num = +this.comment_stats.score_comment;
        suffix = '人评价';
      } else {
        num = +this.comment_stats.expect_num;
        suffix = '人想玩';
      }
      if (num >= 100000000) {
        num = Number(num / 100000000).toFixed(1) + '亿';
      } else if (num >= 10000) {
        num = Number(num / 10000).toFixed(1) + '万';
      } else {
        num = num || 0;
      }
      return num + suffix;
    },
    priceDesc() {
      let region_name = this.price.region_name
        ? this.price.region_name + ' '
        : '';
      let lowest = this.price.new_lowest
        ? '新历史最低 '
        : this.price.is_lowest
          ? '历史最低 '
          : '';
      let deadline = this.price.deadline_date || '';
      return region_name + lowest + deadline;
    },
    couponDesc() {
      return (
        this.heybox_price &&
        this.heybox_price.coupon_info &&
        this.heybox_price.coupon_info.coupon_desc
      );
    },
    getStrLen() {
      return (str) => {
        let length = 0;
        let re = /[\u4E00-\u9FA5]/;
        for (let char of str) {
          length += re.test(char) ? 2 : 1;
        }
        return length;
      };
    },
    heybox_protocol() {
      let protocol = {
        protocol_type: 'openGameDetail',
        app_id: this.appid,
        game_type: this.game_type,
        open_source: '/game/detail',
        page_identifier: JSON.stringify({
          appid: this.appid,
        }),
      };
      if (this.h_src) {
        protocol.h_src = window.btoa(this.h_src);
      }
      return 'heybox://' + JSON.stringify(protocol);
    },
  },
  created() {
    this.appid = getUrlParam('appid') || getUrlParam('steam_appid');
    this.game_type = getUrlParam('game_type');
    this.getData();
    reportDataWeb({
      path: '/web/game/game_detail_share',
      type: '1',
      addition: {
        appid: this.appid,
        game_type: this.game_type,
        h_src: this.h_src || '',
      },
    });
    if (this.judegeCanUseDeepLink()) {
      document.addEventListener('WeixinOpenTagsError', function (e) {
        this.canUseDeepLink = false;
      });
    }
    this.reportShare('visit');
  },
  mounted() {
    this.getComments();
  },
  methods: {
    reportShare(action) {
      this.$reportShare({
        action,
        extra: {
          appid: this.appid,
        },
        source: '/game/detail',
      });
    },
    menuClickHandler(menu) {
      console.log(menu.type);
      if (menu.type == 'homepage') {
        window.location.href = menu.key;
      } else if (menu.type == 'qq') {
        new ClipboardJS('.qq');
      } else {
        this.reportShare('download');
        this.openInHeybox();
      }
    },
    getData() {
      let params = {};
      if (this.game_type === 'console') {
        params.appid = this.appid;
      } else if (this.game_type === 'mobile') {
        params.appid = this.appid;
      } else {
        params.steam_appid = this.appid;
      }
      getGameDetail(this.game_type, params).then((res) => {
        if (res.data.status == 'ok') {
          let data = res.data.result;

          this.shareConfig = {
            title: data.share_data?.share_title || data.share_title,
            desc: data.share_data?.share_desc || data.share_desc,
            link: window.location.href,
            imgUrl: data.share_data?.share_img || data.share_img,
          };
          this.getWeixindata();

          this.screenshots = data.screenshots;
          if (data.heybox_price) {
            this.heybox_price = data.heybox_price;
          }
          this.display_add_wishlist = data.display_add_wishlist;
          if (data.price) {
            this.price = data.price;
          }
          this.name = data.name;
          this.name_en = data.name_en;
          this.score = -1;
          if (data.score) {
            this.score = parseFloat(data.score).toFixed(1);
          }

          let common_tags = data.common_tags || [];
          this.simple_tags = common_tags.filter(
            (el) => el.type === 'simple_tag',
          );
          this.steam_aggres = common_tags.filter(
            (el) =>
              el.type === 'steam_aggre' &&
              el.desc_list &&
              el.desc_list.length > 0,
          );
          this.heybox_tags = common_tags.filter(
            (el) => el.type === 'heybox_tag',
          );

          if (data.platforms) {
            this.platforms = data.platforms;
          } else if (data.platforms_list) {
            this.platforms = data.platforms_list.map((item) => {
              return item.platf;
            });
          }
          this.platf = data.platf || (this.platforms && this.platforms[0]);

          if (data.user_num && data.user_num.game_data) {
            this.data_list = data.user_num.game_data;
          }

          this.is_official = data.is_official || 0;
          this.about_the_game = data.about_the_game;
          if (data.menu_v2) {
            this.menus = data.menu_v2;
          }
          this.comment_stats = data.comment_stats;

          setTimeout(() => {
            this.showLoading = false;
            this.$nextTick(() => {
              this.chartPeakLine();
            });
          }, 100);
        }
      });
    },
    getWeixindata() {
      getShareInfo().then((res) => {
        if (res.data.status == 'ok') {
          const weixindata = res.data.result;
          wxShare(weixindata, this.shareConfig, true);
        }
      });
    },
    judegeCanUseDeepLink() {
      // 微信版本号大于 7.0.12 开放标签才可进行 唤醒 app 跳转
      const wechatInfo = window.navigator.userAgent.match(
        /MicroMessenger\/([\d\.]+)/i,
      );
      if (!wechatInfo) return false;
      let judgewechat = wechatInfo[1].split('.');
      if (judgewechat[0] >= 7 && judgewechat[1] >= 0 && judgewechat[2] >= 12) {
        this.canUseDeepLink = true;
        return true;
      } else {
        this.canUseDeepLink = false;
        return false;
      }
    },
    chartPeakLine() {
      let peak_values = [];
      let time_arr = [];
      for (let i = 0; i < this.data_list.length; i++) {
        let p_v = this.data_list[i].peak_values;
        if (p_v && p_v.length > 0) {
          peak_values = p_v.map((item) => {
            time_arr.push(item.time);
            return item.peak_value;
          });
          break;
        }
      }
      if (peak_values.length > 0) {
        this.chart = echarts.init(document.querySelector('.peak-canvas'));
        this.chart.setOption({
          grid: {
            top: '0',
            left: '0',
            right: '0',
            bottom: '0',
          },
          xAxis: {
            type: 'category',
            data: time_arr,
            show: false,
          },
          yAxis: {
            type: 'value',
            show: false,
          },
          series: [
            {
              type: 'line',
              data: peak_values,
              areaStyle: {
                color: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    { offset: 0, color: 'rgba(100,105,110,0.4)' },
                    { offset: 0.97, color: 'rgba(100,105,110,0)' },
                  ],
                },
              },
              itemStyle: {
                borderWidth: 0,
                opacity: 0,
                color: '#14191e',
              },
              lineStyle: {
                width: 1,
                color: '#14191e',
              },
            },
          ],
        });
      }
    },
    getComments() {
      getGameComments({
        appid: this.appid,
        offset: 0,
        limit: 10,
      }).then((res) => {
        let data = res.data.result;
        this.comments = data.links || [];

        this.$nextTick(() => {
          Array.from(
            document.querySelectorAll('.comments-item .description'),
          ).forEach((item, index) => {
            if (item.clientHeight > 110) {
              this.$set(this.comments[index], 'showBtn', true);
            }
          });
        });
      });
    },
    openInHeybox() {
      this.reportShare('click_open');
      executeProtocolOutApp(this.heybox_protocol);
    },
    getHtml(rich) {
      return getDomByJson(rich).outerHTML;
    },
  },
  filters: {
    formatCoin(coin) {
      return ~~(coin / 1000);
    },
  },
  components: {
    HeaderShare,
    Medias,
    CommentItem,
    PercentrRing,
    OutOpen,
  },
};
</script>

<style lang="less">
@import '~_style/common.css';
@import './assets/style/index.less';

#app {
  width: 100%;
  max-width: 640px;
  min-height: 100vh;
  margin: 0 auto;
}
html,
body {
  background-color: #f7f8f9;
}
</style>
